import { render } from "./ShadowSizesView.vue?vue&type=template&id=0ff42864"
import script from "./ShadowSizesView.vue?vue&type=script&lang=js"
export * from "./ShadowSizesView.vue?vue&type=script&lang=js"

import "./ShadowSizesView.vue?vue&type=style&index=0&id=0ff42864&lang=scss"

import exportComponent from "/home/runner/work/acnh-tracker/acnh-tracker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__